angular.module('shared-calendar')
    .controller('SharedCalendarBatchDeleteModalController', function (SharedCalendar, $uibModalInstance) {
        this.$onInit = () => {
            this.form = {
                owners: [],
                users: []
            };
        };

        this.save = () => SharedCalendar.reject(this.form).$promise.then(result => $uibModalInstance.close(result));

        this.cancel = () => $uibModalInstance.dismiss('Canceled');
    })
